import { uniqueId } from 'lodash'
import React, { FC, useState } from 'react'
import COLOR_LIST from '../../constants/taskColor'
import Tips from '../common/Tips'

interface Props {
  color: string
  changeCallback: (color: string) => void
}

const AddColorModule: FC<Props> = (props) => {
  const {
    color,
    changeCallback,
  } = props

  const [isDisplay, setIsDisplay] = useState<boolean>(false)

  const open = () => {
    setIsDisplay(true)
  }

  const close = () => {
    setIsDisplay(false)
  }

  const changeColor = (selectColor: string) => {
    changeCallback(selectColor)
    setIsDisplay(false)
  }

  return (
    <>
      <div className="color_area">
        <button
          type="button"
          onClick={() => open()}
        >
          <div
            className="color"
            style={{
              backgroundColor: color || "#EEEEEE",
            }}
          />
          {COLOR_LIST.map((v) => v.values).flat().find((v) => v.color === color)?.text || "無設定"}
        </button>
        <div className={`search_box ${isDisplay || 'none'}`}>
          {
            COLOR_LIST.map((colors) => (
              <React.Fragment key={uniqueId()}>
                <div className="color_title">
                  {colors.name}
                </div>
                <div className="color_list">
                  {
                    colors.values.map((value) => (
                      <div key={uniqueId()}>
                        <Tips
                          description={value.text}
                          className=""
                          icon={false}
                        >
                          <div
                            key={uniqueId()}
                            onClick={() => changeColor(value.color)}
                            role="none"
                            className="color"
                            style={{
                              backgroundColor: value.color,
                            }}
                          />
                        </Tips>
                      </div>
                    ))
                  }
                </div>
              </React.Fragment>
            ))
          }
        </div>
      </div>
      <div className={`close_screen ${isDisplay || 'none'}`} role="presentation" onClick={() => close()} />
    </>
  )
}

export default AddColorModule
